import { RootState } from '../store.types';

export const hasReceivedUsersSelector = ({ users: reducer }: RootState) => reducer.hasReceivedUsers;

export const usersSelector = ({ users: reducer }: RootState) => reducer.users;
